<h2 class="text-center mt-3">Matriz de Documentos</h2>
<hr>
<div *ngIf="stage1" class="divPrincipal">
  <div class="row justify-content-center">
    <div class="col-lg-3 col-md-4 col-sm-8 col-xs-12 mb-3">
      <h3 #h3>Nuevo Documento</h3>
    </div>
  </div>
  <div class="row justify-content-center">

    <div class="col-lg-3 col-md-4 col-sm-8 col-xs-12">
      <app-select titulo="Entidad" value="id" text="title" [disabled]="true" [items]="entidades$ | async"
        [search]="true" [selection]="selectedEntidad"></app-select>
    </div>

  </div>

  <div class="row justify-content-center">
    <div class="col-lg-3 col-md-4 col-sm-8 col-xs-12">
      <app-select [optional]="false" [search]="true" titulo="Tipo documento" value="tIDValor" text="tDescripcionValor"
        [items]="TipoDocumento$ | async" [(selection)]="selectedTipoDocumento">
      </app-select>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-lg-3 col-md-4 col-sm-8 col-xs-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label class="LabelTitulo">Nombre Documento</mat-label>
        <input matInput class="InputText" [(ngModel)]="nombre_doc" required>
      </mat-form-field>
    </div>
  </div>

  <div class="row justify-content-center mt-3">
    <div class="col-lg-2 col-md-3 col-sm-8 col-xs-12">
      <button color="primary" mat-raised-button class="w-100" (click)="ClickSiguiente()">
        <span>Siguiente</span>
      </button>
    </div>


  </div>

</div>

<div *ngIf="stage2" class="divPrincipal">
  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
      <h3>Documento</h3>
    </div>
  </div>

  <div class="row justify-content-center align-items-center">

    <div class="col-lg-3 col-md-4 col-sm-8 col-xs-12">
      <app-select titulo="Grupo Variable" value="id" text="descripcion" [items]="grupoVariables" [search]="true"
        [(selection)]="selectedGrupoVariables" (itemClick)="ChangeVariable($event.id, undefined)"></app-select>
    </div>
    <div class="col-lg-3 col-md-4 col-sm-8 col-xs-12">
      <app-select titulo="Variable" value="id" text="descripcion" [items]="subVariables" [search]="true"
        [(selection)]="selectedSubVariable"
        (itemClick)="SaveValue($event.nombreVariable,$event.descripcion,$event.tipoCampo);">
      </app-select>
    </div>
    <div class="col-lg-1 col-md-1 col-sm-8 col-xs-12 text-center">
      <button mat-raised-button color="primary" (click)="CopyValue()">
        <mat-icon [ngStyle]="{'color':'white'}">file_copy</mat-icon>
      </button>
    </div>
    <div class="col-lg-1 col-md-1 col-sm-8 col-xs-12 text-center">
      <button *ngIf="createButton" (click)="open(mymodal)" mat-raised-button color="primary">
        <mat-icon [ngStyle]="{'color':'white'}">add_circle_outline</mat-icon>Crear
      </button>
    </div>

  </div>


  <ng-template #mymodal let-modal>
    <div class="modal-header">
      <h2 class="modal-title" id="modal-basic-title">Crear Variable</h2>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">

      <div class="row justify-content-center">

        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
          <mat-form-field class="w-100 " appearance="outline">
            <mat-label class="LabelTitulo">Nombre Variable</mat-label>
            <input matInput class="InputText" [(ngModel)]="nombre_NVariable" required>
          </mat-form-field>


        </div>

        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
          <app-select class="w-100" [optional]="false" [search]="true" titulo="Tipo campo" value="tIDValor"
            text="tDescripcionValor" [items]="TipoCampo$ | async" [(selection)]="selectedTipoCampo"
            (itemClick)=SaveTipoCampo($event.tDescripcionValor)>
          </app-select>
        </div>

        <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">

          <mat-form-field class="w-100" appearance="outline">
            <mat-label class="LabelTitulo">Descripcion Variable</mat-label>
            <input matInput class="InputText" [(ngModel)]="descripcion_NVariable" required>
          </mat-form-field>

        </div>

      </div>

      <div *ngIf="agregarValores">

        <div class="row justify-content-center">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3 class="text-center mt-1">Multivalores</h3>
          </div>
        </div>

        <div class="row justify-content-center">

          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label class="LabelTitulo">Nombre SubTabla</mat-label>
              <input matInput class="InputText" [(ngModel)]="nombre_SubTabla" required>
            </mat-form-field>
          </div>

        </div>



        <div class="dark-bg mt-4" *ngIf="agregarValores">

          <div class="row justify-content-center align-items-center ">

            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 mt-2">
              <h3 class="text-center">Valores</h3>
            </div>

            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 mt-1">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label class="LabelTitulo">Descripción</mat-label>
                <input matInput class="InputText" [(ngModel)]="new_descripcion" required>
              </mat-form-field>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-lg-5 col-md-5 col-sm-10 col-xs-10 mb-1">
              <app-select class="w-100" [optional]="true" [search]="true" titulo="Tipo Parametro" value="tIDValor"
                text="tDescripcionValor" [items]="TipoParametro$ | async" [(selection)]="selectedTipoParametro"
                (itemClick)=SaveTipo($event.tIDValor,$event.tDescripcionValor);>
              </app-select>
            </div>

            <div class="col-lg-5 col-md-5 col-sm-10 col-xs-10 mb-1">
              <mat-form-field *ngIf="selectedTipoParametro == 1" class="w-100" appearance="outline">
                <mat-label class="LabelTitulo">Valor</mat-label>
                <input matInput class="numberInput number w-100" [(ngModel)]="new_valor" type="number" step="0.1">
              </mat-form-field>
              <mat-form-field *ngIf="selectedTipoParametro == 2" class="w-100" appearance="outline">
                <mat-label class="LabelTitulo">Valor</mat-label>
                <input matInput [matDatepicker]="dp" [(ngModel)]="new_valor">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp></mat-datepicker>
              </mat-form-field>

              <div *ngIf="selectedTipoParametro == 3" class="w-100 mt-2">
                <mat-checkbox class="checklist-leaf-node" [(ngModel)]="new_valor">Verdadero
                </mat-checkbox>
              </div>
              <mat-form-field *ngIf="selectedTipoParametro == 4" class="w-100" appearance="outline">
                <mat-label class="LabelTitulo">Valor</mat-label>
                <input matInput [(ngModel)]="new_valor" type="text">
              </mat-form-field>
              <mat-form-field *ngIf="selectedTipoParametro == 5" class="w-100" appearance="outline">
                <mat-label class="LabelTitulo">Valor</mat-label>
                <input matInput class="numberInput number w-100" [(ngModel)]="new_valor" type="number" step="1">
              </mat-form-field>


            </div>




          </div>


          <div class="row justify-content-center">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 mb-1">
              <button (click)="AddValor();" mat-raised-button color="primary">
                <mat-icon [ngStyle]="{'color':'white'}">add</mat-icon> Agregar
              </button>
            </div>

            <div class="col-lg-7 col-md-7 col-sm-10 col-xs-10 mb-1"></div>

          </div>

          <div class="row justify-content-center mt-4 p-2">
            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-12 mb-10 table-responsive">

              <table class="table table-hover mat-elevation-z8">

                <thead>
                  <tr class="tHeader">
                    <td>ID</td>
                    <td>Orden</td>
                    <td>Descripcion</td>
                    <td>Tipo Parametro</td>
                    <td>Valor</td>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let variable of valores_agregados;let i = index;" class="tHeader">
                    <td>{{variable.tIDValor}}</td>
                    <td>{{variable.iOrden}}</td>
                    <td>{{variable.tDescripcionValor}}</td>
                    <td>{{variable.dTipoParametro}}</td>
                    <td>{{variable.stringDate}}</td>
                    <td>
                      <button (click)="DeleteValor(i,valores_agregados);Reordenar(valores_agregados);" mat-mini-fab
                        color="warn">
                        <mat-icon [ngStyle]="{'color':'white'}">delete_outline</mat-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>

              </table>

            </div>

          </div>

        </div>


      </div>


    </div>
    <div class="modal-footer">
      <button mat-raised-button color="warn" class="mx-2" type="button"
        (click)="modal.close('Cancel');CleanModal();">Cancelar</button>
      <button mat-raised-button color="primary" class="mx-2" type="button" (click)="SaveNVariable(); ">Guardar</button>
    </div>
  </ng-template>

  <div class="row justify-content-center mt-4 mb-2">
    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 mb-5 table-responsive">
      <table class="table table-hover mat-elevation-z8" data-pagination="true" data-toggle="table">

        <thead>
          <tr class="tHeader">
            <td>#</td>
            <td>Nombre Variable</td>
            <td>Descripcion</td>
            <td>Tipo Campo</td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let variable of selectedVariablesList;let i =index" class="tHeader">
            <td>{{i+1}}</td>
            <td>{{variable[1]}}</td>
            <td>{{variable[0]}}</td>
            <td>{{variable[2]}}</td>
            <td>
              <button (click)="DeleteValorMessage(i);DeleteValor(i, selectedVariablesList);" mat-mini-fab color="warn">
                <mat-icon [ngStyle]="{'color':'white'}">delete_outline</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>

  <div class="row justify-content-center mb-4">
    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 mb-5">
      <angular-editor #angularEditor [(ngModel)]="contenido" [config]="config"></angular-editor>

    </div>
  </div>

  <div class="row justify-content-center my-2">
    <div class="col-lg-2 col-md-2 col-sm-10 col-xs-10 mb-5">
      <button mat-raised-button color="primary" class="w-100" (click)="SaveMatrizDocumento()">
        Guardar
      </button>
    </div>
  </div>

</div>